(function () {
  function initStickyATC() {
    const realButton = document.querySelector('form[action*="/cart/add"] [type="submit"]');
    const bar = document.getElementById('sticky-atc');
    const stickyBtn = document.getElementById('sticky-atc-btn');
    const footer = document.querySelector('.footer');

    if (!realButton || !bar || !stickyBtn) return;

    let hideBecauseButtonVisible = false;
    let hideBecauseFooterVisible = false;

    function updateStickyState() {
      const shouldHide = hideBecauseButtonVisible || hideBecauseFooterVisible;
      bar.classList.toggle('hidden', shouldHide);
      document.body.classList.toggle('has-sticky-atc', !shouldHide);
    }

    const buttonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          hideBecauseButtonVisible = entry.isIntersecting;
          updateStickyState();
        });
      },
      { threshold: 0 }
    );

    buttonObserver.observe(realButton);

    if (footer) {
      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            hideBecauseFooterVisible = entry.isIntersecting;
            updateStickyState();
          });
        },
        {
          threshold: 0,
          rootMargin: '0px 0px 90px 0px'
        }
      );

      footerObserver.observe(footer);
    }

    if (!stickyBtn.dataset.stickyBound) {
      stickyBtn.addEventListener('click', () => {
        realButton.click();
      });
      stickyBtn.dataset.stickyBound = 'true';
    }
  }

  document.addEventListener('DOMContentLoaded', initStickyATC);
  document.addEventListener('shopify:section:load', initStickyATC);
})();